module.exports = __webpack_public_path__ + "static/media/outside-straight.d30db545.jpg";